import {
  DollarSign,
  FileText,
  Mail,
  PackageCheck,
  Printer,
  Ship,
  Upload,
  User,
  X,
} from "lucide-react";
import moment from "moment";
import React from "react";

function ExpandedDetails({
  shipment,
  setExpandedRow,
  charges,
  setFileUploadVisible,
  setSelectedOrderId,
  onPrintShipment,
  type="",
  width,
  left=0,
  onOpenMail,
}) {
  const formatDate = (date) => {
  const m = moment(date);

  if (!m.isValid()) {
    return date; // return original if invalid
  }

  return m.format("DD MMM YYYY HH:mm");
};
  const details = {
    fileInfo: {
      createDate: formatDate(shipment?.createdOn),
      createdBy: shipment?.createdBy,
      bookingNumber: shipment?.carrierBookingNumber || " ",
      customerId: shipment?.customerReference,
      oceanCarrier: shipment?.carrier || "ZIM-AMERICAN ISRAELI SHIPPING CO.",
      vesselName: shipment?.vessel,
    },
    customerInfo: {
      nameAddress: shipment?.customerName || "Customer Name",
      pol: shipment?.portOfLoading || "NEW YORK (NY) (DEPT)",
      pod: shipment?.portOfDischarge,
      finalDestination: shipment?.countryOfDestination,
      coDate: formatDate(shipment?.portCo),
      docCoDate: formatDate(shipment?.ourDocCo),
      ets: formatDate(shipment?.etsAtPol),
      eta: formatDate(shipment?.etaAtPod),
    },
    contactInfo: {
      shipping: shipment?.shipper,
      Consignee: shipment?.consignee,
    },
    containerDetails: {
      quantity: shipment?.containerCount,
      type: shipment?.containerType,
    },
  };

  return (
    <div className="bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-900 p-6 border-t border-slate-300 dark:border-slate-700 relative" style={width?{width:width,left:left}:null} >
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-slate-800 dark:text-white">
          Booking Details
        </h3>
        <button
          onClick={() => setExpandedRow(null)}
          className="p-1 text-slate-500 hover:text-red-500 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <div className="flex flex-wrap gap-6">
        {/* File Information Section */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 flex-1 flex-grow min-w-[320px] max-w-[520px]">
          <div className="flex items-center gap-2 mb-3 pb-2 border-b border-slate-200 dark:border-slate-700">
            <FileText className="w-4 h-4 text-blue-500" />
            <h4 className="font-semibold text-slate-800 dark:text-white">
              FILE INFORMATION
            </h4>
          </div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                File Create Date:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.fileInfo.createDate}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Created By:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.fileInfo.createdBy}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Booking Number:
              </span>
              <span className="font-medium text-blue-600 dark:text-blue-400">
                {details.fileInfo.bookingNumber}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Customer PO:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.fileInfo.customerId}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Ocean Carrier:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.fileInfo.oceanCarrier}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Vessel Name:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.fileInfo.vesselName}
              </span>
            </div>
          </div>
        </div>

        {/* ROUTING INFORMATION Section */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4  w-full flex-1 min-w-[320px] max-w-[520px]">
          <div className="flex items-center gap-2 mb-3 pb-2 border-b border-slate-200 dark:border-slate-700">
            <Ship className="w-4 h-4 text-green-500" />
            <h4 className="font-semibold text-slate-800 dark:text-white">
              ROUTING INFORMATION
            </h4>
          </div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Name & Address:
              </span>
              <span className="font-medium text-slate-800 dark:text-white text-right">
                {details.customerInfo.nameAddress}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">POL:</span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.customerInfo.pol}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">POD:</span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.customerInfo.pod}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Final Destination:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.customerInfo.finalDestination || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                C/O Date:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.customerInfo.coDate}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">
                Doc. C/O Date:
              </span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.customerInfo.docCoDate}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">ETS:</span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.customerInfo.ets}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600 dark:text-slate-400">ETA:</span>
              <span className="font-medium text-slate-800 dark:text-white">
                {details.customerInfo.eta}
              </span>
            </div>
          </div>
        </div>

        {/* Contact & Container Section */}
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4  flex-1 min-w-[320px] max-w-[520px]">
          <div className="space-y-4">
            {/* Contact Information */}
            <div>
              <div className="flex items-center gap-2 mb-3 pb-2 border-b border-slate-200 dark:border-slate-700">
                <User className="w-4 h-4 text-purple-500" />
                <h4 className="font-semibold text-slate-800 dark:text-white">
                  CUSTOMER INFORMATION
                </h4>
              </div>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-slate-600 dark:text-slate-400">
                    Shipping:
                  </span>
                  <span className="font-medium text-slate-800 dark:text-white text-right">
                    {details.contactInfo.shipping}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600 dark:text-slate-400">
                    Consignee:
                  </span>
                  <span className="font-medium text-slate-800 dark:text-white">
                    {details.contactInfo.Consignee}
                  </span>
                </div>
                {/* <div className="flex justify-between">
                                        <span className="text-slate-600 dark:text-slate-400">Container Details:</span>
                                        <span className="font-medium text-slate-800 dark:text-white">{details.contactInfo.fax}</span>
                                    </div> */}
              </div>
            </div>

            {/* Container Details */}
            <div>
              <div className="flex items-center gap-2 mb-3 pb-2 border-b border-slate-200 dark:border-slate-700">
                <PackageCheck className="w-4 h-4 text-orange-500" />
                <h4 className="font-semibold text-slate-800 dark:text-white">
                  CONTAINER DETAILS
                </h4>
              </div>
              <div className="text-sm">
                <div className="flex justify-between items-center bg-slate-50 dark:bg-slate-900 p-2 rounded">
                  <span className="font-medium text-slate-800 dark:text-white">
                    {details.containerDetails.quantity} X{" "}
                    {details.containerDetails.type}
                  </span>
                  <span className="text-xs text-slate-500">Container Type</span>
                </div>
              </div>
            </div>

            {/* Charges Table */}
            <div>
              <div className="flex items-center gap-2 mb-3 pb-2 border-b border-slate-200 dark:border-slate-700">
                <DollarSign className="w-4 h-4 text-emerald-500" />
                <h4 className="font-semibold text-slate-800 dark:text-white">
                  CHARGES
                </h4>
                <span className="text-xs text-slate-500 ml-auto">
                  {charges?.length || 0} charges
                </span>
              </div>

              {charges && charges.length > 0 ? (
                <div className="text-sm">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-slate-200 dark:border-slate-700">
                        <th className="text-left py-2 px-1 text-slate-600 dark:text-slate-400 text-xs font-semibold">
                          CHARGE NAME
                        </th>
                        <th className="text-left py-2 px-1 text-slate-600 dark:text-slate-400 text-xs font-semibold">
                          UNIT
                        </th>
                        <th className="text-left py-2 px-1 text-slate-600 dark:text-slate-400 text-xs font-semibold">
                          SELL
                        </th>
                        <th className="text-left py-2 px-1 text-slate-600 dark:text-slate-400 text-xs font-semibold">
                          BUY
                        </th>
                        <th className="text-left py-2 px-1 text-slate-600 dark:text-slate-400 text-xs font-semibold">
                          MODE
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {charges
                        .filter((rate) => !rate.isDeleted)
                        .map((rate, index) => (
                          <tr
                            key={rate.rateId || index}
                            className={`border-b border-slate-100 dark:border-slate-700 ${index % 2 === 0 ? "bg-slate-50 dark:bg-slate-800/50" : ""}`}
                          >
                            <td className="py-2 px-1 text-slate-700 dark:text-slate-300">
                              {rate.descriptions || rate.descCode || "N/A"}
                              {/* {rate.allIn && (
                                                                <span className="ml-1 text-xs bg-blue-100 text-blue-800 px-1.5 py-0.5 rounded">All-in</span>
                                                            )} */}
                              {/* {rate.isDisputeAr && (
                                                                <span className="ml-1 text-xs bg-red-100 text-red-800 px-1.5 py-0.5 rounded">AR Dispute</span>
                                                            )}
                                                            {rate.isDisputeAp && (
                                                                <span className="ml-1 text-xs bg-orange-100 text-orange-800 px-1.5 py-0.5 rounded">AP Dispute</span>
                                                            )} */}
                            </td>
                            <td className="py-2 px-1 text-slate-700 dark:text-slate-300">
                              <div className="flex flex-col">
                                {/* <span>{rate.contType || 'N/A'}</span> */}
                                <span className="text-xs text-slate-500">
                                  Qty: {rate.quantity || 0}
                                </span>
                              </div>
                            </td>
                            <td className="py-2 px-1 text-slate-700 dark:text-slate-300">
                              <div className="flex flex-col">
                                <span className="font-medium text-green-600 dark:text-green-400">
                                  {rate.sellAmount?.toLocaleString() || "0"}
                                </span>
                                {/* <span className="text-xs text-slate-500">{rate.currency} @ {rate.sellRate || 0}</span>
                                                                <span className="text-xs text-slate-400">To: {rate.chrgBillToPartyName || 'N/A'}</span> */}
                              </div>
                            </td>
                            <td className="py-2 px-1 text-slate-700 dark:text-slate-300">
                              <div className="flex flex-col">
                                <span className="font-medium text-red-600 dark:text-red-400">
                                  {rate.buyAmount?.toLocaleString() || "0"}
                                </span>
                                {/* <span className="text-xs text-slate-500">@ {rate.buyRate || 0}</span>
                                                                <span className="text-xs text-slate-400">Vendor: {rate.vendorName || 'N/A'}</span> */}
                              </div>
                            </td>
                            <td className="py-2 px-1 text-slate-700 dark:text-slate-300">
                              <div className="flex flex-col">
                                <span
                                  className={`px-2 py-0.5 rounded text-xs w-fit ${rate.paymentMode === "Prepaid" ? "bg-green-100 text-green-800" : "bg-blue-100 text-blue-800"}`}
                                >
                                  {rate.paymentMode || "N/A"}
                                </span>
                                {/* {rate.basis && <span className="text-xs text-slate-500 mt-1">Basis: {rate.basis}</span>}
                                                                {rate.roe && <span className="text-xs text-slate-500">ROE: {rate.roe}</span>} */}
                              </div>
                            </td>
                          </tr>
                        ))}

                      {/* Totals Row */}
                      {charges.filter((rate) => !rate.isDeleted).length > 0 && (
                        <tr className="bg-slate-100 dark:bg-slate-800 font-semibold">
                          <td className="py-2 px-1 text-slate-800 dark:text-white">
                            TOTAL
                          </td>
                          <td className="py-2 px-1 text-slate-800 dark:text-white">
                            {charges
                              .filter((rate) => !rate.isDeleted)
                              .reduce(
                                (sum, rate) => sum + (rate.quantity || 0),
                                0,
                              )}
                          </td>
                          <td className="py-2 px-1 text-green-600 dark:text-green-400">
                            {charges
                              .filter((rate) => !rate.isDeleted)
                              .reduce(
                                (sum, rate) => sum + (rate.sellAmount || 0),
                                0,
                              )
                              .toLocaleString()}
                          </td>
                          <td className="py-2 px-1 text-red-600 dark:text-red-400">
                            {charges
                              .filter((rate) => !rate.isDeleted)
                              .reduce(
                                (sum, rate) => sum + (rate.buyAmount || 0),
                                0,
                              )
                              .toLocaleString()}
                          </td>
                          <td className="py-2 px-1 text-slate-700 dark:text-slate-300">
                            Profit:{" "}
                            {(
                              charges
                                .filter((rate) => !rate.isDeleted)
                                .reduce(
                                  (sum, rate) => sum + (rate.sellAmount || 0),
                                  0,
                                ) -
                              charges
                                .filter((rate) => !rate.isDeleted)
                                .reduce(
                                  (sum, rate) => sum + (rate.buyAmount || 0),
                                  0,
                                )
                            ).toLocaleString()}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {/* Payment Status Indicators */}
                  {charges.some((rate) => rate.arPaid || rate.apPaid) && (
                    <div className="mt-3 flex flex-wrap gap-2">
                      {charges.some((rate) => rate.arPaid) && (
                        <span className="text-xs bg-emerald-100 text-emerald-800 px-2 py-1 rounded">
                          ✓ AR Paid
                        </span>
                      )}
                      {charges.some((rate) => rate.apPaid) && (
                        <span className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded">
                          ✓ AP Paid
                        </span>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-sm">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-slate-200 dark:border-slate-700">
                        <th className="text-left py-1 text-slate-600 dark:text-slate-400">
                          CHARGE NAME
                        </th>
                        <th className="text-left py-1 text-slate-600 dark:text-slate-400">
                          UNIT
                        </th>
                        <th className="text-left py-1 text-slate-600 dark:text-slate-400">
                          SELL
                        </th>
                        <th className="text-left py-1 text-slate-600 dark:text-slate-400">
                          BUY
                        </th>
                        <th className="text-left py-1 text-slate-600 dark:text-slate-400">
                          MODE
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          colSpan="5"
                          className="py-3 text-center text-slate-500 dark:text-slate-400 italic"
                        >
                          No freight Details Available
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
   {type !=="shipmentlist"  &&  <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-slate-300 dark:border-slate-700">
        <button
          onClick={() => onPrintShipment(shipment?.id)}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all flex items-center gap-2"
        >
          <Printer className="w-4 h-4" />
          Print Details
        </button>
        <button className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-all flex items-center gap-2" onClick={()=>onOpenMail(shipment)}>
          <Mail className="w-4 h-4" />
          Email Details
        </button>
        <button
          onClick={() => {
            setSelectedOrderId(shipment);
            setFileUploadVisible(true);
          }}
          className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition-all flex items-center gap-2"
        >
          <Upload className="w-4 h-4" />
          Upload Documents
        </button>
      </div>}
    </div>
  );
}

export default ExpandedDetails;